import { authorizedEdgeFetch } from 'app/axios/edge'

export function getDealershipImageUploadURL(domainId: string) {
  return authorizedEdgeFetch.put<{}, { data: { payload: string } }>(
    `rms/domains/${domainId}/image/`
  )
}
